import React from 'react';
import { Box, Typography } from '@mui/material';
import { useBranding } from '../context/BrandingContext';
const LOGO_HEIGHT = {
  sm: 32,
  md: 36,
  lg: 40
};

/**
 * Horizontal logo + institution name. Falls back to name-only when no logo.
 *
 * @param {object} props
 * @param {'sm' | 'md' | 'lg'} [props.size='md']
 * @param {number} [props.logoHeight] Override logo height in px (optional)
 * @param {boolean} [props.noWrap=true] When false, name may wrap (e.g. long titles)
 * @param {string} [props.variant='h6'] MUI Typography variant for name
 * @param {object} [props.sx] Extra sx on root Box
 * @param {string} [props.nameColor] Theme palette path or CSS color for name text
 */
const InstitutionBrandRow = ({
  size = 'md',
  logoHeight: logoHeightProp,
  noWrap = true,
  variant = 'h6',
  sx,
  nameColor = 'text.primary',
  name
}) => {
  const {
    branding,
    displayShortName,
    hasLogo
  } = useBranding();
  const h = logoHeightProp ?? LOGO_HEIGHT[size] ?? LOGO_HEIGHT.md;
  return <Box sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1.25,
    minWidth: 0,
    ...sx
  }}>
      {hasLogo && <Box component="img" src={branding.logoUrl} alt="" sx={{
      height: h,
      width: 'auto',
      maxWidth: {
        xs: 200,
        sm: 260
      },
      objectFit: 'contain',
      flexShrink: 0
    }} />}
      <Typography component="span" variant={variant} noWrap={noWrap} sx={{
      color: nameColor,
      letterSpacing: '-0.02em',
      minWidth: 0,
      lineHeight: noWrap ? 1.2 : 1.3,
      ...(!noWrap && {
        whiteSpace: 'normal'
      })
    }}>
        {name || displayShortName}
      </Typography>
    </Box>;
};
export default InstitutionBrandRow;
